var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1627,
    height: 999,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-59 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.5 394.804C227.5 364.26 252.26 339.5 282.804 339.5L1628.2 339.5C1658.74 339.5 1683.5 364.26 1683.5 394.804L1683.5 1193.2C1683.5 1223.74 1658.74 1248.5 1628.2 1248.5L282.804 1248.5C252.26 1248.5 227.5 1223.74 227.5 1193.2Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#45B382",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 351.865C185.5 321.288 210.288 296.5 240.865 296.5L1585.14 296.5C1615.71 296.5 1640.5 321.288 1640.5 351.865L1640.5 1151.14C1640.5 1181.71 1615.71 1206.5 1585.14 1206.5L240.865 1206.5C210.288 1206.5 185.5 1181.71 185.5 1151.14Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#D5A7CB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 309.864C143.5 279.287 168.287 254.5 198.864 254.5L1543.14 254.5C1573.71 254.5 1598.5 279.287 1598.5 309.864L1598.5 1109.14C1598.5 1139.71 1573.71 1164.5 1543.14 1164.5L198.864 1164.5C168.287 1164.5 143.5 1139.71 143.5 1109.14Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#F9677E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 384.609C185.5 362.457 203.458 344.5 225.609 344.5L1516.39 344.5C1538.54 344.5 1556.5 362.457 1556.5 384.609L1556.5 1081.39C1556.5 1103.54 1538.54 1121.5 1516.39 1121.5L225.609 1121.5C203.458 1121.5 185.5 1103.54 185.5 1081.39Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Han Santteut Dotum,Han Santteut Dotum_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 147,
    transform: "matrix(1 0 0 1 440.311 692)"
  }, "\uC131\uC778\uC9C0"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Han Santteut Dotum,Han Santteut Dotum_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 147,
    transform: "matrix(1 0 0 1 890.051 692)"
  }, "\uAC10\uC218\uC131"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Han Santteut Dotum,Han Santteut Dotum_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 147,
    transform: "matrix(1 0 0 1 596.718 868)"
  }, "\uC790\uAC00\uC9C4\uB2E8"), /*#__PURE__*/React.createElement("path", {
    d: "M227 302C227 287.641 238.641 276 253 276 267.359 276 279 287.641 279 302 279 316.359 267.359 328 253 328 238.641 328 227 316.359 227 302Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#45B382",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 302C322 287.641 333.641 276 348 276 362.359 276 374 287.641 374 302 374 316.359 362.359 328 348 328 333.641 328 322 316.359 322 302Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#FFD600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 302C416 287.641 427.641 276 442 276 456.359 276 468 287.641 468 302 468 316.359 456.359 328 442 328 427.641 328 416 316.359 416 302Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "#FBFFFA",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTitle);
export default __webpack_public_path__ + "static/media/box_title.c099c16f485f9e2f2999aa5f5a30da5a.svg";
export { ForwardRef as ReactComponent };